import Image from 'next/image';
import { Box, Card, CardContent } from '@mui/material';
import styled from '@emotion/styled';
import { shouldForwardProps } from '../../utils';
import { BodyMedium, Center, Column } from '../../styles';
import { Breakpoint, isExpanded } from '../../types';
import { Terminal } from '@mui/icons-material';

const InfoContainer = styled(Box, shouldForwardProps)`
    display: flex;
    flex-direction: column;
    gap: ${({ theme }) => theme.spacing(2)};
`;

const TitlePicture = styled(Image)`
    object-fit: cover;
    aspect-ratio: auto 3/4;
    width: 100%;
    height: auto;
`;

const TitlePicturePlaceHolder = styled(Center)`
    background-color: ${({ theme }) => theme.colors.secondaryDark};
    height: 260px;
`;

const ProfileMainContainer = styled(Box, shouldForwardProps)<{ breakpoint: Breakpoint }>`
    display: flex;
    flex-direction: ${({ breakpoint }) => (isExpanded(breakpoint) ? 'row' : 'column')};
    gap: ${({ theme }) => theme.spacing(1.5)};
    align-items: flex-start;
`;

const ProfileRightContainer = styled(Box, shouldForwardProps)<{ breakpoint: Breakpoint }>`
    display: flex;
    flex-direction: column;
    gap: ${({ theme }) => theme.spacing(1.5)};
    width: ${({ breakpoint }) => (isExpanded(breakpoint) ? '35%' : '100%')};
    padding-bottom: ${({ theme }) => theme.spacing(2)};
`;

const EmptyProfileContainer = styled(Column)`
    align-items: center;
    gap: ${({ theme }) => theme.spacing(5)};
    padding: ${({ theme }) => theme.spacing(6)};
`;

const EmptyProfileTextContainer = styled(Column)`
    max-width: 600px;
    gap: ${({ theme }) => theme.spacing(1)};
    text-align: center;
`;

const InstitutionControls = styled(Box, shouldForwardProps)`
    display: flex;
    flex-direction: row;
    justify-self: flex-end;
    gap: ${({ theme }) => theme.spacing(2)};
    margin-bottom: ${({ theme }) => theme.spacing(1)};
`;

const SoftwareSection = styled(Column, shouldForwardProps)`
    background-color: ${({ theme }) => theme.colors.onPrimaryDark};
    padding: ${({ theme }) => theme.spacing(3)};
    padding-top: ${({ theme }) => theme.spacing(4)};
    padding-bottom: ${({ theme }) => theme.spacing(4)};
    gap: ${({ theme }) => theme.spacing(4)};
`;

const SoftwareGrid = styled(Box, shouldForwardProps)`
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(350px, 1fr));
    gap: ${({ theme }) => theme.spacing(3)};
    width: 100%;
`;

const SoftwareCard = styled(Card, shouldForwardProps)`
    gap: ${({ theme }) => theme.spacing(1)};
    max-width: 450px;
    width: 100%;
`;

const SoftwareIcon = styled(Terminal)`
    height: 40px;
    width: 40px;
    border-radius: 20px;
    padding: 10px;
    background-color: ${({ theme }) => theme.colors.secondaryDark};
`;

const SoftwareCardContent = styled(CardContent)`
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    height: -webkit-fill-available;
    gap: ${({ theme }) => theme.spacing(2)};
`;

const SoftwareDescription = styled(BodyMedium)`
    display: -webkit-box;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: normal;
    width: inherit;
    height: inherit;
`;

const InstitutionCard = styled(Card, shouldForwardProps)`
    height: auto;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    padding: ${({ theme }) => theme.spacing(2)};
    gap: ${({ theme }) => theme.spacing(1)};
    overflow: hidden;
    background-color: ${({ theme }) => theme.colors.outlineVariant};
    border-radius: 4px;
`;
const InstitutionCardContent = styled(CardContent)`
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    height: -webkit-fill-available;
    gap: ${({ theme }) => theme.spacing(2)};
`;


export {
    InfoContainer,
    TitlePicture,
    TitlePicturePlaceHolder,
    ProfileMainContainer,
    ProfileRightContainer,
    EmptyProfileContainer,
    EmptyProfileTextContainer,
    InstitutionControls,
    SoftwareSection,
    SoftwareGrid,
    SoftwareCard,
    SoftwareIcon,
    SoftwareDescription,
    SoftwareCardContent,
    InstitutionCard,
    InstitutionCardContent
};
